<template>
  <div id="footer" style="background-color: black; padding: 30px">
    <vs-row>
      <vs-col w="4" lg="4" xs="12" sm="12">
        <!-- Desarrollado por <br>
        <img src="https://storage.googleapis.com/balde-1/various/logos/circonio/white_motto.svg" alt="Logo de Circonio" width="48%" />
        <span style="display: inline-block; border-left: 1px solid #FFF; margin: 0 10px; height: 100px;"></span>
        <img src="https://anvico.club/editores/img/new/newIcons/Anvi_CO_blanco.png" alt="Logo de Anvi" width="45%" /> -->
        <img src="https://storage.googleapis.com/balde-1/various/logos/videnti_svg/white.svg" alt="Logo de Videnti" style="width: 100%" />
        <br>
        &copy; 2022 - Videnti / Anvi<br>
        {{ $t("footer.no_video_is_stored_by_us") }}
        <br>
        <select v-model="$i18n.locale" @change="cambiarIdioma">
          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ lang }}
          </option>
        </select>
      </vs-col>
      <vs-col w="2" lg="2" sm="0" xs="0" class="hideWhenSM">

      </vs-col>
      <vs-col w="2" lg="2" sm="4" xs="4">
        <h4>{{ $t("footer.header_navigation") }}</h4>
        <ul>
          <li><a href="/watch/collection/editor-picks">{{ $t("footer.navigation.editors_pick") }}</a></li>
          <li><a href="/watch/collection/fall-2021">{{ $t("footer.navigation.this_season") }}</a></li>
          <li><a href="/calendar">{{ $t("footer.navigation.calendar") }}</a></li>
          <li><a href="/community">{{ $t("footer.navigation.community") }}</a></li>
          <li><a href="https://news.videnti.co/">{{ $t("footer.navigation.news") }}</a></li>
        </ul>
      </vs-col>
      <vs-col w="2" lg="2" sm="4">
        <h4>Nuestras redes</h4>
        <ul>
          <li><a href="https://www.youtube.com/channel/UC7YqzBLFeMyvz17jxrnRPsQ"> <i class="bx bxl-youtube"></i> YouTube</a></li>
          <li><a href="https://twitter.com/AnviServer"> <i class="bx bxl-twitter"></i> Twitter</a></li>
        </ul>
      </vs-col>
      <vs-col w="2" lg="2" sm="4">
        <h4>Videnti</h4>
        <ul>
          <li><a href="/">Inicio</a></li>
          <li><a href="/pages/about-us">Acerca de nosotros</a></li>
          <li><a href="/pages/faq">FAQ</a></li>
          <li><a href="/pages/contact-us">Contacto</a></li>
          <li><a href="/pages/tos">Términos del Servicio</a></li>
          <li><a href="/pages/what-about-my-privacy">Política de Privacidad</a></li>
        </ul>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { usePageStatusStore } from '@/stores/pageStatus'; // Ajusta la ruta a tu store

export default {
  name: "Footer",
  data () {
    return { langs: ['es', 'eo'] }
  },
  methods: {
    // Traemos la función setLanguage de Pinia a nuestros methods
    ...mapActions(usePageStatusStore, ['setLanguage']),

    cambiarIdioma() {
      // Llamamos a la acción de Pinia
      this.setLanguage(this.$i18n.locale);
    }
  }
}
</script>

<style scoped>
li, li a {
  margin-bottom: 5px;
  color: #8b8b8b;
  text-decoration: none;
  transition: 0.3s;
}
li a:hover {
  /* text-decoration: underline; */
  color: aliceblue;
}

@media (max-width: 900px) {
  .hideWhenSM {
    width: 0;
  }
}
</style>
